import { jsx as a } from "react/jsx-runtime";
function f(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var c = { exports: {} };
var p;
function m() {
  return p || (p = 1, (function(r) {
    (function() {
      var e = {}.hasOwnProperty;
      function s() {
        for (var t = "", n = 0; n < arguments.length; n++) {
          var o = arguments[n];
          o && (t = i(t, u.call(this, o)));
        }
        return t;
      }
      function u(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return s.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var n = "";
        for (var o in t)
          e.call(t, o) && t[o] && (n = i(n, this && this[o] || o));
        return n;
      }
      function i(t, n) {
        return n ? t ? t + " " + n : t + n : t;
      }
      r.exports ? (s.default = s, r.exports = s) : window.classNames = s;
    })();
  })(c)), c.exports;
}
var _ = m();
const v = /* @__PURE__ */ f(_), d = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, x = v.bind(d), l = "purpur-icon", w = ["xxs", "xs", "sm", "md", "lg", "xl"], g = "md", h = (r) => r.filter((e) => Object.keys(e).length >= 1).map((e) => `${e.name}="${e.value}"`).join(" "), y = ({ content: r = "", title: e } = {}) => {
  const s = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    e ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], u = e ? `<title>${e}</title>` : "";
  return `<svg ${h(s)}>${u}${r}</svg>`;
}, S = (r) => r.replace(/<(\/?)svg([^>]*)>/g, "").trim(), b = ({ svg: r, allyTitle: e, className: s, size: u = g, ...i }) => {
  const t = y({
    content: S(r.svg),
    title: e
  }), n = x(l, `${l}--${u}`, s);
  return /* @__PURE__ */ a("span", { className: n, dangerouslySetInnerHTML: { __html: t }, ...i });
};
b.displayName = "Icon";
export {
  g as DEFAULT_SIZE,
  b as Icon,
  w as sizes
};
//# sourceMappingURL=icon.es.js.map
